const LogNames = {
    // expand card
    entityNamesFlag: 'EN',
    activityType: 'AT',
    tailoredActionName: 'AN',
    isExpanded: 'EX',
    isEditable: 'IE',

    // User voice
    entityNamesMap: 'EN',
    feedbackActionType: 'AN', // defaultState = 0, sendFeedback = 1, reportIssue = 2
    origin: 'OR',
    source: 'SO', // MailReact = 1, CalendarPeek = 2, CalendarForm = 4
    dataPointName: 'DPN',

    isEventSharedSuccessfully: 'ESS',

    endState: 'ES',
    tailoredEntityState: 'TES',
    teeEmailDonationRequested: 'ED',
    isTxpObjectValid: 'TV',
};

export default LogNames;
